import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import dayjs from 'src/libs/dayjs';

import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.Note>({
  selectId: (model) => model.id,
  sortComparer: (a, b) => {
    return dayjs(a.created_at).isBefore(b.created_at) ? -1 : 1;
  },
});

const { reducer, actions } = createSlice({
  name: 'note',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Note[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Note>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<Model.Note>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.note,
);

export const selectNoteByContentId = createSelector(
  selector.selectAll,
  (state: RootState) => state.ui.app.me?.id,
  (state: RootState, class_topic_content_id?: string) => class_topic_content_id,
  (notes, user_id, class_topic_content_id) => {
    return notes.filter((note) => {
      return (
        note.class_topic_content_id === class_topic_content_id &&
        note.user_id === user_id
      );
    });
  },
);

export { reducer };
export default actions;
